export default {
  "hierarchy": {
    "success": [
      "progressBar-success"
    ],
    "danger": [
      "progressBar-danger"
    ]
  },
  "props": {
    "default": {
      "labelVariant": "captionCurrent",
      "completeLabelVisible": true,
      "icons": null,
      "labelVisible": true
    },
    "success": {
      "labelVariant": "captionCurrent",
      "completeLabelVisible": true,
      "icons": null,
      "labelVisible": true
    },
    "danger": {
      "labelVariant": "captionCurrent",
      "completeLabelVisible": true,
      "icons": null,
      "labelVisible": true
    }
  }
}